import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { apiRequest } from './apiClient';
import './auth.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  // On-screen reset link surfaced when SendGrid is not yet configured.
  const [resetLink, setResetLink] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setInfo(null); setError(null); setResetLink(null);
    setSubmitting(true);
    try {
      const { ok, data } = await apiRequest('POST', `${BACKEND_URL}/api/auth/forgot-password`, {
        body: { email },
      });
      if (!ok) {
        setError(typeof data.detail === 'string' ? data.detail : 'Request failed.');
        return;
      }
      setInfo(data.message || 'If an account exists for this email, a reset link has been sent.');
      if (data.reset_link) setResetLink(data.reset_link);
    } catch (err) {
      setError('Network error: ' + err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card" data-testid="forgot-card">
        <div className="auth-brand"><span className="auth-brand-dot"></span> Estatel AI</div>
        <h1 className="auth-title">Forgot password</h1>
        <p className="auth-subtitle">Enter your email and we'll send you a link to reset your password.</p>
        {info && <div className="auth-success" data-testid="forgot-info">{info}</div>}
        {resetLink && (
          <div
            data-testid="forgot-onscreen-link"
            style={{
              background: '#fef9c3', border: '1px solid #fde047', color: '#713f12',
              padding: '0.75rem 0.85rem', borderRadius: 6, fontSize: '0.85rem',
              marginBottom: '1rem', wordBreak: 'break-all',
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: 4 }}>
              Email delivery is not yet configured. Use this reset link directly:
            </div>
            <a href={resetLink} style={{ color: '#0073EA', fontWeight: 500 }}>{resetLink}</a>
          </div>
        )}
        {error && <div className="auth-error" data-testid="forgot-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="auth-field">
            <label htmlFor="forgot-email">Email address</label>
            <input id="forgot-email" type="email" value={email} onChange={e => setEmail(e.target.value)} required autoComplete="email" data-testid="forgot-email" />
          </div>
          <button
            type="submit"
            disabled={submitting}
            style={{
              width: '100%', background: submitting ? '#94a3b8' : '#0073EA', color: '#fff',
              border: 'none', borderRadius: 6, padding: '0.7rem', fontSize: '0.95rem',
              fontWeight: 500, cursor: submitting ? 'not-allowed' : 'pointer', marginTop: '0.5rem',
            }}
            data-testid="forgot-submit"
          >
            {submitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <div className="auth-footer">
          <Link to="/login" data-testid="forgot-back-link">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
